module.exports = __webpack_public_path__ + "static/media/carrington.192a90f3.png";